import { Link, useNavigate } from "react-router-dom";
import FormContainer from "../components/common/FormElements/FormContainer";
import FormHeader from "../components/common/FormElements/FormHeader";
import Input from "../components/common/FormElements/Input";
import SubmitButton from "../components/common/FormElements/SubmitButton";
import { ChangeEvent, useState, FormEvent } from "react";
import { ErrorType } from "../types/errorType";
import FormError from "../components/common/FormElements/FormError";

type ForgotDataType = {
  email: string;
};

const Forgot = () => {
  const [data, setData] = useState<ForgotDataType>({
    email: "",
  });

  // naviage
  const navigate = useNavigate();

  // loading state
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // error state
  const [isError, setIsError] = useState<ErrorType>({
    errorType: "",
    errorMessage: "",
  });

  const changeHander = (e: ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(data);
    // set all error property to empty on submit the form
    setIsError({
      errorType: "",
      errorMessage: "",
    });

    // start loading
    setIsLoading(true);

    // if any input field is empty it will give error message under the form or go to the next step
    if (!data.email) {
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "error",
          errorMessage: "Please fill the field",
        });
      }, 500);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "success",
          errorMessage: "OTP sent to your email",
        });
      }, 500);
      setTimeout(() => {
        navigate("/complete-registration");
      }, 1000);
    }
  };

  return (
    <FormContainer>
      <FormHeader
        labelText="Forgot your password?"
        subheading="Please enter the email you use to sign in to Zissanger."
      />
      <form
        className="w-full flex flex-col gap-5"
        onSubmit={(e: FormEvent<HTMLFormElement>) => formHandler(e)}
      >
        <Input
          inputType="email"
          placeholder="Enter email Address"
          icon="fa-solid fa-at"
          inputName="email"
          value={data.email}
          handler={changeHander}
        />
        <SubmitButton buttonLabel="Continue" isLoading={isLoading} />
        {isError.errorType && <FormError errorObject={isError} />}
      </form>
      <div className="">
        <Link
          to={"/login"}
          className="text-violet-500 w-max sm:text-sm md:text-base"
        >
          Back to Login
        </Link>
      </div>
    </FormContainer>
  );
};

export default Forgot;
